import { emotionIcons } from "../modules/Member/View/Components/Post/Like/constants";
import type { PostReactionTypes } from "../shared/types";

export const getReactionInfo = (type?: PostReactionTypes) => {
	return emotionIcons.find(x => x.value === type);
};
